import { memo } from "react";
import { useI18n } from "./integrations/formatjs/I18nContext";
import { shallowEqual } from "./utils/shallowEqual";
const I18nMessage = ({ domain, id, prefix = "", defaultMessage, values, }) => {
    const intl = useI18n({ domain });
    const translationId = `${prefix}${id}`;
    return intl.formatMessage({ id: translationId, defaultMessage: defaultMessage || translationId }, values);
};
const MemoizedI18nMessage = memo(I18nMessage, shallowEqual);
export { MemoizedI18nMessage as I18nMessage };
